import { Container, Content, Heading, SettingSectionContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import PersonTableView, { IReceiverMember } from "./uis/table-view/person-table-view";
import { useEffect, useState } from "react";
import { getAlarmReceiver, setAlarmReceiver } from "apis/meeting-room-complain/alarm-receiver";
import SlackTableView from "./uis/table-view/slack-table-view";
import {
  connectComplainSlackChannel,
  getComplainSlackChannel,
  IAlarmChannel,
} from "apis/meeting-room-complain/alarm-channel";
import { getMessengers, TSlackChannel } from "apis/messangers";
import { useToast } from "hook/useToast";
import { AddMeetingManagerModal, AddMeetingSlackModal } from "uis/modal";
import { TMember } from "types/user.types";

const ComplainManagerSetting = () => {
  const { showToast } = useToast();
  const [openAddComplainPersonModal, setOpenAddComplainPersonModal] = useState(false);
  const [complainManagerList, setComplainManagerList] = useState<IReceiverMember[]>([]);
  const [openAddComplainSlackModal, setOpenAddComplainSlackModal] = useState(false);
  const [complainSlackList, setComplainSlackList] = useState<IAlarmChannel[]>([]);
  const [getUsageSlack, setGetUsageSlack] = useState<boolean>(false);

  const getMessenger = async () => {
    const res = await getMessengers();
    if (res.data?.some((item) => item.messengerProvider === "SLACK")) {
      setGetUsageSlack(true);
    } else setGetUsageSlack(false);
  };

  const getComplainManagerList = async () => {
    const res = await getAlarmReceiver();
    if (res.success) {
      setComplainManagerList(res.data ?? []);
    } else {
      setComplainManagerList([]);
    }
  };

  const getComplainSlackList = async () => {
    const res = await getComplainSlackChannel();
    if (res.success) setComplainSlackList(res.data ?? []);
  };

  //* 슬랙 채널 추가
  const onHandleAddChannel = async (channelInfo?: TSlackChannel) => {
    if (!channelInfo) return;
    const res = await connectComplainSlackChannel(channelInfo);
    if (res.success) {
      showToast(`슬랙 민원 채널 "${channelInfo.slackChannelName}"이 추가되었습니다.`, "success");
      getComplainSlackList();
      setOpenAddComplainSlackModal(false);
    } else {
      showToast("슬랙 민원 채널 추가에 실패했습니다. 재시도해 주세요.", "error");
      setOpenAddComplainSlackModal(false);
    }
  };

  //* 민원 담당자 추가
  const onHandleAddManagerList = async (selectedMembers: TMember[]) => {
    const res = await setAlarmReceiver(selectedMembers);
    if (res.success) {
      if (selectedMembers.length === 1)
        showToast(`민원 담당자 "${selectedMembers[0].nickname}"이 추가되었습니다.`, "success");
      else
        showToast(
          `민원 담당자 "${selectedMembers[0].nickname}"외 ${selectedMembers.length - 1}인이 추가되었습니다.`,
          "success"
        );
      getComplainManagerList();
      setOpenAddComplainPersonModal(false);
    } else {
      showToast("담당자 추가에 실패했습니다. 재시도해 주세요.", "error");
    }
  };

  useEffect(() => {
    getComplainManagerList();
    getComplainSlackList();
    getMessenger();
  }, []);

  return (
    <Container style={{ minWidth: 1120 }}>
      <div className="content">
        <Heading>
          <UI.Typography
            style={{ padding: "24px 20px" }}
            color="var(--alias-color-label-neutral)"
            type="title03"
            fontStyle="bold"
          >
            민원 담당자 설정
          </UI.Typography>
        </Heading>
        <Content>
          <SettingSectionContainer>
            <div className="header">
              <div className="label">
                <UI.Typography type="headline01" fontStyle="medium" color="var(--alias-color-label-normal)">
                  민원 담당자
                </UI.Typography>
                <UI.Typography type="body01 normal" color="var(--alias-color-label-alternative)">
                  회의실 내에서 민원이 등록되면 담당자들에게 알림이 전송됩니다.
                </UI.Typography>
              </div>
              <UI.Button
                title="담당자 추가하기"
                prefixIcon="addPerson"
                primary={false}
                showPrefixIcon
                onClick={() => setOpenAddComplainPersonModal(true)}
              />
            </div>
            <PersonTableView managers={complainManagerList} onUpdate={() => getComplainManagerList()} />
          </SettingSectionContainer>
          <SettingSectionContainer>
            <div className="header">
              <div className="label">
                <UI.Typography type="headline01" fontStyle="medium" color="var(--alias-color-label-normal)">
                  민원 슬랙 채널
                </UI.Typography>
                <UI.Typography type="body01 normal" color="var(--alias-color-label-alternative)">
                  회의실 내에서 민원이 등록되면 슬랙 채널로 알림이 전송됩니다.
                </UI.Typography>
              </div>
              <UI.Button
                disabled={!getUsageSlack}
                title="슬랙 채널 추가하기"
                prefixIcon="view"
                primary={false}
                showPrefixIcon
                onClick={() => {
                  if (getUsageSlack) {
                    setOpenAddComplainSlackModal(true);
                  } else {
                    showToast("슬랙 미연동 상태입니다. 슬랙 연동 후 채널을 추가해 주세요.", "warning");
                  }
                }}
              />
            </div>
            <SlackTableView
              channels={complainSlackList}
              onUpdate={() => getComplainSlackList()}
              disabled={!getUsageSlack}
            />
          </SettingSectionContainer>
        </Content>
      </div>
      <AddMeetingSlackModal
        title="민원 슬랙 채널 추가"
        modalIsOpen={openAddComplainSlackModal}
        onUpdate={getComplainSlackList}
        closeModal={() => setOpenAddComplainSlackModal(false)}
        onHandleAddChannel={onHandleAddChannel}
        onHandleGuide={() => {
          window.open(
            "https://mile-corporation.notion.site/134a222a9c1b80ad9e76fc8869103496#134a222a9c1b801ea726fe31fe0cf531"
          );
        }}
      />
      <AddMeetingManagerModal
        title="민원 담당자 추가"
        modalIsOpen={openAddComplainPersonModal}
        onHandleAddManager={onHandleAddManagerList}
        closeModal={() => setOpenAddComplainPersonModal(false)}
      />
    </Container>
  );
};

export default ComplainManagerSetting;
